import './SectionTextView.css';
export default {
    "wrapper": "SectionTextView_wrapper__9ec80",
    "title": "SectionTextView_title__9ec80",
    "content": "SectionTextView_content__9ec80"
};
